import StatusBadge from "@/components/StatusBadge";

export const columns = () => {
  return [
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "order",
      header: "Order",
      size: 60,
      cell: ({ row }) => (
        <div className={"flex justify-center"}>{row.getValue("order")}</div>
      ),
    },
    {
      accessorKey: "sport",
      header: "Sport ID",
      cell: ({ row }) => <div>{row.original.sport?.name}</div>,
    },
    {
      accessorKey: "code",
      header: "ID",
    },
    {
      accessorKey: "name",
      header: "Player Type",
    },
  ];
};
